// removed by extract-text-webpack-plugin
module.exports = {"age-limit-wrapper":"age-limit-wrapper","age-container":"age-container","form-input":"form-input","select-age-wrapper":"select-age-wrapper","age-limit-label":"age-limit-label","Select-control":"Select-control","Select-menu-outer":"Select-menu-outer","locale-EN":"locale-EN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Form/Fields/AgeLimit/AgeLimit.scss
// module id = E7Sy
// module chunks = 0